<template>
  <fieldset v-if="options">
    <slot></slot>
    <select @change="handleSelectChange">
      <option
        :type="type === 'single' ? 'radio' : 'checkbox'"
        v-for="(option, index) in filterOptions"
        :key="index"
        :value="option.value"
        :selected="option.checked"
      >
        {{ option.label }}
      </option>
    </select>
  </fieldset>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  props: {
    options: {
      type: Array,
      required: true,
    },
    type: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      filterOptions: [],
    };
  },
  computed: {
    ...mapGetters({
      vuexCheckboxFilters: "cludo/checkboxFilters",
      vuexSelectedCheckboxFilters: "cludo/selectedCheckboxFilters",
    }),
  },
  methods: {
    ...mapActions({
      vuexSetCheckboxFilters: "cludo/setCheckboxFilters",
      vuexSetSelectedCheckboxFilters: "cludo/setSelectedCheckboxFilters",
      vuexSetUpdateUrl: "cludo/setUpdateUrl",
    }),

    saveOptionsToStore() {
      const options = [...this.options];

      const checkedOptions = options.filter((el) => el.checked === true);
      this.vuexSetSelectedCheckboxFilters([
        ...this.vuexSelectedCheckboxFilters,
        ...checkedOptions,
      ]);
    },

    initializeCheckBox() {
      // Check if this instance of checkbox component is the last child
      const islastComponentInstance = this.checkIfLastComponentInstance();
      if (this.$cludo.useQuery) {
        // If useQuery check the url and enable the filter checkbox that is included in the url
        this.filterOptions = this.options.map((option) => {
          let isChecked = false;
          const filterUrlValues = this.$getSearchParameter(
            `filter${option.field}`
          );

          if (filterUrlValues) {
            const filterArr = filterUrlValues.split(",");
            const value = option.value.split(",")[0];

            if (filterArr.includes(value)) {
              isChecked = true;
            }
            this.vuexSetUpdateUrl(false);
          } else {
            isChecked = option.checked ?? false;
            this.vuexSetUpdateUrl(true);
          }
          return {
            ...option,
            checked: isChecked,
          };
        });
      } else {
        this.filterOptions = this.options.map((option) => ({
          ...option,
          checked: option.checked ?? false,
        }));
      }

      if (islastComponentInstance) {
        this.vuexSetUpdateUrl(true);
      } else {
        this.vuexSetUpdateUrl(false);
      }

      this.vuexSetCheckboxFilters([
        ...this.vuexCheckboxFilters,
        ...this.filterOptions,
      ]);
    },

    checkIfLastComponentInstance() {
      let checkboxComponentArr = [];
      let islastComponent = false;
      const parentNode = this.$parent;
      const childrenNode = parentNode.$children;
      if (childrenNode?.length > 0) {
        childrenNode.forEach((el) => {
          const componentName = el.$vnode.componentOptions.tag ?? "";
          if (componentName === "cludo-vue-check-boxes") {
            checkboxComponentArr.push(el);
          }
        });
      }
      if (checkboxComponentArr.length > 0) {
        //Get last instance of checkbox and see if it has the same id with the current component
        if (
          checkboxComponentArr.at(-1).$vnode.componentInstance._uid ===
          this._uid
        ) {
          islastComponent = true;
        }
      }
      return islastComponent;
    },

    checkFilter(option) {
      //If Single option (Radio button) then check only one option
      if (this.type === "single") {
        this.filterOptions.forEach((o) => {
          if (o.name === option.name) {
            o.checked = option.checked;
          } else {
            o.checked = false;
          }
        });
      }

      const updatedCheckboxFilters = this.updateFiltersInCheckBoxFilter();
      this.vuexSetUpdateUrl(true);
      this.vuexSetCheckboxFilters(updatedCheckboxFilters);
    },

    // Function to update filter status in the store array to the current state using filter options array
    updateFiltersInCheckBoxFilter() {
      return this.vuexCheckboxFilters.map(
        (obj) => this.filterOptions.find((o) => o.name === obj.name) || obj
      );
    },

    handleSelectChange(event) {
      if (event) {
        const selectedValue = event.target.value;
        const selectedOption = this.filterOptions.find(
          (option) => option.value === selectedValue
        );
        // mimic expected checkbox settings
        selectedOption.checked = true;
        selectedOption.type = "single";

        // the below will add it to the filters in a way that can be cleared
        this.checkFilter(selectedOption);
      }
    },
  },

  mounted() {
    this.initializeCheckBox();
    this.saveOptionsToStore();
  },

  watch: {
    "$store.state.cludo.checkboxFilters": {
      handler(newVal, oldVal) {
        if (newVal && newVal !== oldVal) {
          // update filter option state with latest value from store
          let newFilterOptions = newVal.filter((o1) =>
            this.filterOptions.some((o2) => o1.name === o2.name)
          );
          this.filterOptions = newFilterOptions;
        }
      },
    },
  },
};
</script>

<style></style>
